import { trigger, state, style, transition, animate } from '@angular/animations';

export const FadeInAnimation = trigger('fadeIn', [
  state('in', style({
    opacity: 1
  })),
  transition('void => *', [
    style({
      opacity: 0,
    }),
    animate('0.4s', style({opacity: 1}))
  ]),
  transition('* => void', [
    animate('0.4s', style({opacity: 0})),
  ])
]);


// WEBPACK FOOTER //
// ./src/app/shared/fade-in.animation.ts